import { CompanyBasic } from 'src/app/app/company/company.model';

export class Product {
    id: number;
    name: string;
    price: number;
    amount: number;
    image: {
        filePath: string,
        fileName: string
    };
    description: string;
    category: number; // słownik
    idCompanyProvider: number;
    companyProvider: CompanyBasic;
}

